/*
 * Define global variable Hades
 **********************************************************************/
var Utils = function () {
};

(function ($) {

	Utils.formatDelay = function(timeDiff, displayTime) {

		var displayTimeStr = "";

		if(Math.abs(timeDiff) < 86400000 /* 24*3600*1000 */){
			displayTimeStr = (displayTime.getHours()<10?"0"+displayTime.getHours():displayTime.getHours());
			displayTimeStr += ':';
			displayTimeStr += (displayTime.getMinutes()<10?"0"+displayTime.getMinutes():displayTime.getMinutes());

		} else {
			displayTimeStr = Math.floor(((Math.abs(timeDiff)/1000)/3600)/24) + ' dia(s)';
		}

		return displayTimeStr;
	};

})(jQuery);